import { LoaderCircle } from 'lucide-react';

import { cls } from '@/utils/cls';

export type LogCountBadgeProps = {
  count?: number;
  isLoading?: boolean;
  className?: string;
};

export function LogCountBadge({
  count,
  isLoading = false,
  className,
}: LogCountBadgeProps) {
  if (isLoading) {
    return (
      <div className="animate-fadeIn transition-opacity duration-300">
        <LoaderCircle
          className={cls('animate-spin text-gray-300', className)}
        />
      </div>
    );
  }

  if (typeof count !== 'number') {
    return null;
  }

  return (
    <span
      className={cls(
        'inline-flex animate-fadeIn items-center rounded-full bg-gray-200 px-2 py-0.5 text-xs font-medium text-gray-700',
        className,
      )}
      aria-label={`${count} logs for this alert`}
    >
      {count}
    </span>
  );
}
